import colorConfig from "./color-config.json";

const COLOR_ENTRIES = colorConfig.colors;

const resolveValue = (compConfig, entry, hasDataConfig) => {
  if (hasDataConfig) {
    const direct = compConfig[entry.configKey];
    if (direct != null) return direct;
    if (entry.fallbackConfigKey) {
      const fallback = compConfig[entry.fallbackConfigKey];
      if (fallback != null) return fallback;
    }
  }
  return entry.default ?? null;
};

const setVar = (style, cssVar, value) => {
  if (value != null) style[cssVar] = value;
};

export const buildThemeStyle = (compConfig, hasDataConfig = false) => {
  const style = {};

  for (const entry of COLOR_ENTRIES) {
    if (entry.derived) continue;
    const value = resolveValue(compConfig, entry, hasDataConfig);
    if (value == null) continue;
    setVar(style, entry.cssVar, value);
    if (entry.extraCssVars) {
      for (const extra of entry.extraCssVars) {
        setVar(style, extra, value);
      }
    }
  }

  const highlight = resolveValue(
    compConfig,
    {
      configKey: "colorSecondary",
      fallbackConfigKey: null,
      default: null,
    },
    hasDataConfig,
  );

  if (
    (hasDataConfig ? compConfig.colorPrimaryHover == null : true) &&
    highlight != null
  ) {
    setVar(style, "--theme-primary-hover", highlight);
  }

  return style;
};

export { colorConfig };
